import javalogo from "../logos/javalogo.jpg"
import swiftlogo from "../logos/swiftlogo.jpg"
import htmllogo from "../logos/htmllogo.png"
import csslogo from "../logos/csslogo.png"
import javascriptlogo from "../logos/javascriptlogo.png"
import typescriptlogo from "../logos/typescriptlogo.png"
import clogo from "../logos/clogo.png"
import cpplogo from "../logos/cpplogo.png"
import csharplogo from "../logos/csharplogo.png"
import pythonlogo from "../logos/pythonlogo.png"
import latexlogo from "../logos/latexlogo.png"
import sqllogo from "../logos/sqllogo.png"
import clojurelogo from "../logos/clojurelogo.png"
import uikitlogo from "../logos/uikitlogo.jpeg"
import swiftuilogo from "../logos/swiftuilogo.png"
import angularlogo from "../logos/angularlogo.png"
import azurelogo from "../logos/azurelogo.svg"
import spigotlogo from "../logos/spigotmclogo.png"
import xamarinlogo from "../logos/xamarinlogo.svg"
import dotnetlogo from "../logos/dotnetlogo.jpg"
import reactlogo from "../logos/reactlogo.png"
import firebaselogo from "../logos/firebaselogo.png"
import xcodelogo from "../logos/xcodelogo.png"
import androidstudiologo from "../logos/androidstudiologo.png"
import bootstraplogo from "../logos/bootstraplogo.png"
import sasslogo from "../logos/sasslogo.png"
import googlemapslogo from "../logos/googlemapslogo.png"
import windowsformslogo from "../logos/windowsformslogo.png"
import gitlogo from "../logos/gitlogo.png"
import githublogo from "../logos/githublogo.png"
import nodejslogo from "../logos/nodejslogo.png"
import wondersharefilmoralogo from "../logos/wondersharefilmoralogo.png"
import audacitylogo from "../logos/audacitylogo.png"
import awslogo from "../logos/awslogo.webp"
import terraformlogo from "../logos/terraformlogo.png"
import spritekitlogo from "../logos/spritekitlogo.png"

const skills = {
    "Terraform" : {
        image : terraformlogo
    },
    "AWS" : {
        image: awslogo
    },
    "Java": {
        image: javalogo
    },
    "Swift": {
        image: swiftlogo
    },
    "HTML": {
        image: htmllogo
    },
    "CSS": {
        image: csslogo
    },
    "JavaScript": {
        image: javascriptlogo
    },
    "TypeScript": {
        image: typescriptlogo
    },
    "C": {
        image: clogo
    },
    "C++": {
        image: cpplogo
    },
    "C#": {
        image: csharplogo
    },
    "Python": {
        image: pythonlogo
    },
    "LaTeX": {
        image: latexlogo
    },
    "SQL": {
        image: sqllogo
    },
    "Clojure": {
        image: clojurelogo
    },
    "UIKit": {
        image: uikitlogo
    },
    "SwiftUI": {
        image: swiftuilogo
    },
    "SpriteKit": {
        image: spritekitlogo
    },
    "Angular": {
        image: angularlogo
    },
    "Azure": {
        image: azurelogo
    },
    "Spigot": {
        image: spigotlogo
    },
    "Xamarin": {
        image: xamarinlogo
    },
    ".NET": {
        image: dotnetlogo
    },
    "React": {
        image: reactlogo
    },
    "Firebase": {
        image: firebaselogo
    },
    "Xcode": {
        image: xcodelogo
    },
    "Android Studio": {
        image: androidstudiologo
    },
    "Bootstrap": {
        image: bootstraplogo
    },
    "Sass": {
        image: sasslogo
    },
    "Google Maps API": {
        image: googlemapslogo
    },
    "Windows Forms": {
        image: windowsformslogo
    },
    "Git": {
        image: gitlogo
    },
    "GitHub Pages": {
        image: githublogo
    },
    "Node.js": {
        image: nodejslogo
    },
    "Wondershare Filmora": {
        image: wondersharefilmoralogo
    },
    "Audacity": {
        image: audacitylogo
    },
}

export default skills;